export const prettySize = (size: number): string => {
  const i = Math.floor(Math.log(size) / Math.log(1024))
  const num = (size / Math.pow(1024, i)).toFixed(2)
  const unit = ['B', 'kB', 'MB', 'GB', 'TB'][i]

  return `${num} ${unit}`
}
